import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m20.3 4.203-8-3.91c-.8-.39-1.8-.39-2.7 0l-8 3.91C.6 4.693 0 5.67 0 6.745v9.287c0 1.075.6 2.15 1.7 2.64l8 3.91c.4.195.9.293 1.3.293.5 0 .9-.098 1.3-.294l8-3.91c1-.489 1.7-1.466 1.7-2.64V6.746c0-1.076-.6-2.054-1.7-2.543m-9.7-2.249c.1-.097.3-.097.4-.097.2 0 .3 0 .4.098l7.4 3.617L11 9.384 3.2 5.572zM2.5 17.01c-.3-.195-.5-.586-.5-.88V7.137l8 3.91v9.58zm16.9 0L12 20.627v-9.58l8-3.91v8.994q0 .586-.6.88z"
    }, null, -1)
  ]))]))
}
export default { render: render }